import {
  getTextValidationState,
  TEXT_LIMITS,
} from "../../../shared/constants/textLimits";

export const TextLengthIndicator = ({
  value,
  className = "",
  showHelperText = true,
  submitError = "",
  min = TEXT_LIMITS.min,
  max = TEXT_LIMITS.max,
  emptyMessage = "",
}) => {
  const validation = getTextValidationState(value, { min, max });

  let helperMessage = "";
  if (submitError) {
    helperMessage = submitError;
  } else if (validation.isEmpty) {
    helperMessage = emptyMessage;
  }

  const stateClass =
    submitError || validation.isTooLong || validation.isEmpty
      ? "is-error"
      : validation.isNearLimit
        ? "is-warning"
        : "";

  return (
    <div className={`text-limit-indicator ${stateClass} ${className}`.trim()}>
    
      {showHelperText && helperMessage ? (
        <div
          className={submitError ? "text-submit-error" : "text-limit-helper"}
        >
          {helperMessage}
        </div>
      ) : null}
    </div>
  );
};
